class AccountDrawer extends HTMLElement {
  constructor() {
    super();
    this.recoverPasswordLink = this.querySelector('.recover_password_link');
    this.recoverCancelBtn = this.querySelector('.recovery-cancel-btn');
    this.loginTitle = this.querySelector('.login-title');
    this.recoverTitle = this.querySelector('.recover-title');
    this.registerShown = false;
    this.loginForm = this.querySelector('.login-form');
    this.recoveryForm = this.querySelector('.recovery-form');
    this.drawer = new Drawer(this);
    this.registerValidator = new RegisterValidator();
    this.loginValidator = new LoginValidator();
    this.setHeaderCartIconAccessibility();

    [this.recoverPasswordLink, this.recoverCancelBtn]
      .forEach(element => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          this.showRecovery();
        });
      });
  }

  connectedCallback() {
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setContentHeight();
  }

  showRecovery() {
    const isHidden = this.recoveryForm.classList.contains('hide');
    if (isHidden) {
      this.recoveryForm.classList.remove('hide');
      this.loginTitle.classList.add('hide');
      this.recoverTitle.classList.remove('hide');
      this.loginForm.classList.add('hide');
    } else {
      this.hideRegister();
    }
  }

  hideRegister() {

    this.recoveryForm.classList.add('hide');
    this.recoverTitle.classList.add('hide');
    this.loginTitle.classList.remove('hide');
    this.loginForm.classList.remove('hide');
  }

  showRegister() {
    if (this.registerShown) {
      this.hideRegister();
      this.registerShown = false;
      this.registerValidator.reset();
      this.querySelector('#login').classList.remove('hide');
      this.querySelector('#register').classList.add('hide');
    } else {
      this.registerShown = true;
      this.loginValidator.reset();
      this.querySelector('#register').classList.remove('hide');
      this.querySelector('#login').classList.add('hide');
      this.setContentHeight();
    }
  }

  setHeaderCartIconAccessibility() {
    const accountLink = document.querySelector('#account-icon-drawer');
    this.drawer.setAccessibility(accountLink);
  }

  open(triggeredBy) {
    this.drawer.open(triggeredBy);
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('AccountDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    this.registerShown && this.setContentHeight();

  }

  setContentHeight() {
    const drowerHeaderH = this.querySelector('.register-drawer__header').offsetHeight;
    const drowerFooterH = this.querySelector('.register-drawer__footer').offsetHeight;
    const drowerContentH = parseInt(window.innerHeight - (drowerHeaderH + drowerFooterH + 54));
    const registerContents = this.querySelector('.register__contents');
    registerContents.style.maxHeight = drowerContentH + 'px';
  }

  close() {
    this.drawer.close();
    this.registerValidator.reset();
    this.loginValidator.reset();
  }

}

customElements.define('account-drawer', AccountDrawer);
